import { ApolloClient } from '@apollo/client';
import { BaseDataProvider, DataProviderParams, DataProviderResult } from '../base/BaseDataProvider';
import { GET_USERS, GET_USER, UPDATE_USER } from '../queries/users.queries';

export class UsersDataProvider extends BaseDataProvider {
  async getList(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    this.logInfo(resource, 'getList', params);
    
    try {
      const result = await this.client.query({
        query: GET_USERS,
        fetchPolicy: 'network-only',
      });

      const data = result.data.users || [];
      this.logSuccess(resource, 'getList', { dataLength: data.length });

      return {
        data,
        total: data.length,
      };
    } catch (error: any) {
      this.logError(resource, 'getList', error, params);
      return { data: [], total: 0 };
    }
  }

  async getOne(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    this.logInfo(resource, 'getOne', params);

    try {
      const result = await this.client.query({
        query: GET_USER,
        variables: { id: params.id },
        fetchPolicy: 'network-only',
      });

      const data = result.data.user;
      this.logSuccess(resource, 'getOne', data);

      return { data };
    } catch (error: any) {
      this.logError(resource, 'getOne', error, params);
      throw error;
    }
  }

  async create(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    // Users creation not implemented in GraphQL schema
    console.log('Create not implemented for users:', params);
    return { data: { id: Date.now(), ...params.data } };
  }

  async update(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    this.logInfo(resource, 'update', params);

    try {
      const { id, ...updateData } = params.data;
      const result = await this.client.mutate({
        mutation: UPDATE_USER,
        variables: { updateUserInput: updateData },
      });

      const data = result.data.updateUser;
      this.logSuccess(resource, 'update', data);

      return { data };
    } catch (error: any) {
      this.logError(resource, 'update', error, params);
      throw error;
    }
  }

  async delete(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    // Users deletion not implemented in GraphQL schema
    console.log('Delete not implemented for users:', params);
    return { data: { id: params.id } };
  }
}
